var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveDiagnosisTemplate($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "disease"
    }
  }, [_vm._v("Diagnózy a výkony dle šablony")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "id": "search",
      "label": "name",
      "track-by": "id",
      "placeholder": "vybrat šablonu",
      "options": _vm.diagnosisTemplates,
      "multiple": false,
      "internal-search": false,
      "close-on-select": true,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": ""
    },
    on: {
      "select": _vm.selectDiagnosisTemplate
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addDiagnosisTemplateButton"
    }
  }, [_vm._v("Přidat podle šablony")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6900dd92","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/AddDiagnosisTemplate.vue
// module id = 541
// module chunks = 0